import TestUserActionTypes from "./testUserActionTypes"

export const toggleDymamicContentTogglesTool = () => async (dispatch) => {
  dispatch({
    type: TestUserActionTypes.TOGGLE_DYNAMIC_CONTENT_TOGGLES_TOOL,
    response: {}
  })
}
export const updateDeductibleSourceName = (sourceName) => async (dispatch) => {
  dispatch({
    type: TestUserActionTypes.UPDATE_DEDUCTIBLE_SOURCE_NAME,
    response: {
      sourceName
    }
  })
}
export const getToggleActionForType = (type: TestUserActionTypes) => () => async (dispatch) => {
  dispatch({ type })
}
export const getToggleActionForTypes = (types: Array<TestUserActionTypes>) => () => async (dispatch) => {
  Promise.all(
    types.map((type) => {
      console.log({ type })
      dispatch({ type })
    })
  )
}
export const updateCustomCoverageText = (customCoverageText) => async (dispatch) => {
  dispatch({
    type: TestUserActionTypes.UPDATE_CUSTOM_COVERAGE_TEXT,
    response: {
      customCoverageText
    }
  })
}
